export default __webpack_public_path__ + "static/media/0055.0f56c489.png";